export default function BankDetails({
  bankName,
  companyName,
  accountNo,
  ifscCode,
  branchAddress,
  accountType,
  qrCodeSrc,
  upiId,
}) {
  return (
    <div className="bg-white rounded-lg shadow-md md:p-8 mb-6 md:mb-8 flex flex-col md:flex-row gap-6 border border-[#E5E5E5]">
      {/* Left Section: Bank Details and UPI ID */}
      <div className="w-full md:w-2/3">
        <table className="table-auto w-full text-sm md:text-base">
          <tbody>
            <tr>
              <td className="py-2 align-top text-[#1D3557]">
                <span className="font-medium">Bank Name</span>
              </td>
              <td className="pl-3 text-[#1D3557]">
                <span className="flex items-center">{bankName}</span>
              </td>
            </tr>
            <tr>
              <td className="py-2 align-top text-[#1D3557]">
                <span className="font-medium">Company Name</span>
              </td>
              <td className="pl-3 text-[#1D3557]">
                <span>{companyName}</span>
              </td>
            </tr>
            <tr>
              <td className="py-2 align-top text-[#1D3557]">
                <span className="font-medium">Account No.</span>
              </td>
              <td className="pl-3 text-[#1D3557]">
                <span className="flex items-center">{accountNo}</span>
              </td>
            </tr>
            <tr>
              <td className="py-2 align-top text-[#1D3557]">
                <span className="font-medium">IFSC Code</span>
              </td>
              <td className="pl-3 text-[#1D3557]">
                <span className="flex items-center">{ifscCode}</span>
              </td>
            </tr>
            <tr>
              <td className="py-2 align-top text-[#1D3557]">
                <span className="font-medium">Branch Address</span>
              </td>
              <td className="pl-3 text-[#1D3557]">
                <span>{branchAddress}</span>
              </td>
            </tr>
            <tr>
              <td className="py-2 align-top text-[#1D3557]">
                <span className="font-medium">Account Type</span>
              </td>
              <td className="pl-3 text-[#1D3557]">
                <span>{accountType}</span>
              </td>
            </tr>
            <tr>
              <td className="py-2 align-top text-[#1D3557]">
                <span className="font-medium">UPI ID</span>
              </td>
              <td className="pl-3 text-[#1D3557]">
                <span className="flex flex-col md:flex-row">
                  {upiId}
                  <button
                    onClick={() =>
                      (window.location.href = `upi://pay?pa=${upiId}&pn=POSUser&cu=INR`)
                    }
                    className="max-w-[200px] md:ml-3 mt-4 md:mt-0 px-3 py-1 text-xs md:text-sm bg-[#FFD700] hover:bg-[#FFE55C] cursor-pointer text-[#1D3557] rounded font-semibold"
                  >
                    Pay Now
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* Right Section: QR Code in Phone-like Container */}
      <div className="w-full md:w-1/3 flex justify-center">
        <div className="border border-[#E5E5E5] rounded-xl shadow-lg bg-gray-50 flex items-center justify-center w-full max-w-[280px] h-[440px] p-4">
          <img
            src={qrCodeSrc}
            alt="QR Code"
            width={220}
            height={220}
            style={{
              width: "auto",
              height: "auto",
              maxWidth: "100%",
              maxHeight: "100%",
            }}
          />
        </div>
      </div>
    </div>
  );
}